import * as React from "react";
import { connectStore } from "../../utils/RefluxConnect";
import { CustomerCartActions } from "../../actions/CustomerCartActions";
import ReplacementButtonStore from "../../stores/ReplacementButtonStore";

import { wrapLazy } from "../LazyWrapper";
const AlternativesButtonWithModal = wrapLazy(React.lazy(() => import("sd_pdp_ui/AlternativesButtonWithModal")));

import type { ArticlePrices, Price, Prices } from "../../model/Prices";
import type { Money } from "../../stores/BaseTypes";
import type { ArticleBadgeControlsItemView } from "./ArticleBadgeControls";
import type { ReplacementButtonState } from "../../stores/ReplacementButtonStore";
type Actions = {
	deleteItem: (bundleId: string, source?: string | null) => void;
};
export type ReplacementButtonProps = Actions &
	ReplacementButtonState & {
		article: ArticleBadgeControlsItemView;
		storeName: string | null | undefined;
	};
export const DisconnectedReplacementButton = ({
	deleteItem,
	cartItemIds,
	storeId,
	isLoggedIn,
	isEmployee,
	article,
	storeName,
}: ReplacementButtonProps) => {
	const deleteReplacementArticle = (bundleId: string) => {
		// wait for the replacement to be added before deleting
		setTimeout(() => deleteItem(bundleId, "replacement-modal"), 1000);
	};

	const pathName = (window && window.location && window.location.pathname) || "";
	const pathType = ["order-entry", "cart"].find((path) => pathName.includes(path));

	return (
		<div className={"article-replacement mfcss_hide-in-side-caddy no-print"}>
			<AlternativesButtonWithModal
				originalArticle={createHeaderArticleData(article, storeId) as any}
				mainBundleCustomerBuyable={false} // true seems to lead to hiding things
				isLoggedIn={isLoggedIn}
				isEmployee={isEmployee}
				isCustomer={!isEmployee}
				storeName={storeName || storeId || ""}
				changedStoreData={{
					id: null,
					lists: [],
					state: "",
				}} // minimal dummy values of the correct types
				pageType={pathType || "UNKNOWN_PAGE"}
				closeAutomatically
				onAddToBasket={() => deleteReplacementArticle(article.bundleId)}
				basketButtonType={"REPLACE"}
				excludedBundleIds={cartItemIds}
			/>
		</div>
	);
};

function createHeaderArticleData(article: ArticleBadgeControlsItemView, storeId: string | null | undefined) {
	const articlePrices: ArticlePrices | null | undefined = article.prices;
	const bundlePrices: Prices | null | undefined = articlePrices ? articlePrices.bundle : null;
	const bundleArticlePrice: Price | null | undefined = bundlePrices ? bundlePrices.article : null;
	const net: Money | null | undefined = bundleArticlePrice ? bundleArticlePrice.net : null;
	const netAmount: OneSimplePrice | null | undefined = net
		? {
				amount: net.amount,
			}
		: null;
	const gross: Money | null | undefined = bundleArticlePrice ? bundleArticlePrice.gross : null;
	const grossAmount: OneSimplePrice | null | undefined = gross
		? {
				amount: gross.amount,
			}
		: null;
	const currency: string | null | undefined = net ? net.currency : null;
	const price =
		articlePrices == null
			? null
			: {
					currency: currency,
					net: netAmount,
					gross: grossAmount,
					isChargedByWeight: article.chargedByWeight,
					isWeightPerPieceArticle: article.weightPerPiece != null,
				};
	return {
		selectedDeliveryMode: article.selectedDeliveryMode,
		price: price,
		availability: article.availability,
		description: article.description || "",
		customerDisplayId: article.displayId,
		imageUrl: article.imageSources.imageUrl1,
		bettyBundleId: article.bundleId,
		storeId: storeId,
	};
}

export const ReplacementButton = connectStore(DisconnectedReplacementButton, ReplacementButtonStore, {
	deleteItem: CustomerCartActions.deleteItem,
} as Actions);
